import { PopupContent } from './PopupContent';

export default PopupContent;
